import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import cls from './ageverifCloseButton.module.sass'
import { closeAgeverif, closeMenu } from '../../store/common/commonSlice'
import { useQueryParams } from '../../hooks/useQueryParams'

const AgeverifCloseButton = () => {
    const isAgeVerifOpened = useSelector<RootState, boolean>((state) => state.common.isAgeVerifOpened)
    const dispatch = useDispatch()

    const { removeMenuParams } = useQueryParams()

    const handleCloseAgeVerif = () => {
        //@ts-ignore
        if (window.ageverif) {
            //@ts-ignore
            window.ageverif.destroy()
            dispatch(closeAgeverif())
            removeMenuParams()
            dispatch(closeMenu())
        }
    }

    if (isAgeVerifOpened) return <div className={cls['closeButton']} onClick={handleCloseAgeVerif}></div>
    return null
}

export default AgeverifCloseButton
